export default {
  title: 'Route Management',
  search: {
    keyword: 'Keyword',
    keywordPlaceholder: 'Chinese or English name',
    routeType: 'Route Type',
    routeTypePlaceholder: 'Select route type',
    routeLevel: 'Route Level',
    routeLevelPlaceholder: 'Select route level',
    status: 'Status',
    statusPlaceholder: 'Select status',
    searchButton: 'Search',
    resetButton: 'Reset'
  },
  actions: {
    add: 'Create',
    reference: 'Reference Platform Data',
    syncRelation: 'Sync Port Relations',
    edit: 'Edit',
    enable: 'Enable',
    disable: 'Disable',
    batchEnable: 'Batch Enable',
    batchDisable: 'Batch Disable',
    recordsCount: '{count} records'
  },
  table: {
    routeLevel: 'Level',
    parent: 'Parent Route',
    routeNameCn: 'Route Name (CN)',
    routeNameEn: 'Route Name (EN)',
    routeNameShort: 'Route Short Name',
    routeType: 'Route Type',
    status: 'Status',
    dataSource: 'Data Source',
    dateModified: 'Updated At',
    operation: 'Operation'
  },
  form: {
    routeType: 'Route Type',
    routeLevel: 'Route Level',
    parent: 'Parent Route',
    routeNameCn: 'Route Name (CN)',
    routeNameEn: 'Route Name (EN)',
    routeNameShort: 'Route Short Name',
    status: 'Status',
    routeTypePlaceholder: 'Select route type',
    routeLevelPlaceholder: 'Select route level',
    parentPlaceholder: 'Select parent route',
    routeNameCnPlaceholder: 'Enter Chinese route name',
    routeNameEnPlaceholder: 'Enter English route name',
    routeNameShortPlaceholder: 'Enter route short name'
  },
  modal: {
    addTitle: 'Create Route',
    editTitle: 'Edit Route',
    referenceTitle: 'Reference Platform Data',
    syncRelationTitle: 'Sync Platform Port Relations',
    syncRelationNotice: 'Only platform routes already referenced by the current tenant are listed.',
    confirmReference: 'Confirm Reference',
    selectedTitle: 'Selected Routes',
    selectedCount: '{count} selected',
    selected: '{count} selected',
    querySelected: '{total} available routes selected by current filters, {excluded} excluded',
    clearSelected: 'Clear',
    platformTitle: 'Platform Route Library',
    platformCount: '{available} available on this page / {total} total',
    selectAllFiltered: 'Select all filtered ({total})',
    taskNotice: '{count} selected. Submission will be handled in task center.',
    excludedPreview: 'Excluded Routes',
    remove: 'Remove',
    restore: 'Restore',
    copyStatus: 'Reference Status',
    copyStatusPlaceholder: 'Select reference status',
    available: 'Available',
    exists: 'Referenced',
    allStatus: 'All'
  },
  routeType: {
    sea: 'Sea Route',
    air: 'Air Route',
    unknown: 'Unknown'
  },
  routeLevel: {
    first: 'Level 1',
    second: 'Level 2',
    third: 'Level 3'
  },
  statusText: {
    enabled: 'Enabled',
    disabled: 'Disabled'
  },
  dataSource: {
    1: 'Platform',
    2: 'Platform Import',
    3: 'Tenant Created',
    4: 'Platform Reference',
    unknown: 'Unknown'
  },
  validation: {
    routeTypeRequired: 'Select route type',
    routeLevelRequired: 'Select route level',
    parentRequired: 'Select parent route',
    routeNameCnRequired: 'Enter Chinese route name',
    routeNameEnRequired: 'Enter English route name',
    routeNameShortRequired: 'Enter route short name',
    routeNameLength: 'Route name must be 128 characters or fewer',
    routeNameShortLength: 'Route short name must be 64 characters or fewer'
  },
  confirm: {
    toggleStatus: 'Confirm to {action} this route?',
    batchToggleStatus: 'Confirm to {action} selected {count} routes?',
    copyTaskRedirectTitle: 'Route Copy Task Submitted',
    copyTaskRedirectContent: 'Large route copy has been submitted to task center. Go view progress?',
    copyTaskRedirectOk: 'Go to Task Center',
    copyTaskRedirectCancel: 'Stay Here',
    relationSyncTaskRedirectTitle: 'Port Relation Sync Task Submitted',
    relationSyncTaskRedirectContent: 'Large port relation sync has been submitted to task center. Go view progress?',
    relationSyncTaskRedirectOk: 'Go to Task Center',
    relationSyncTaskRedirectCancel: 'Stay Here'
  },
  messages: {
    loadError: 'Failed to load routes',
    parentLoadError: 'Failed to load parent routes',
    platformLoadError: 'Failed to load platform routes',
    saveSuccess: 'Saved successfully',
    saveError: 'Failed to save',
    duplicateRouteName: 'A route with the same Chinese and English names already exists under this parent. Please adjust the names.',
    statusSuccess: 'Status updated',
    statusError: 'Failed to update status',
    selectWarning: 'Select routes to {action}',
    selectReferenceWarning: 'Select routes to reference',
    referenceSuccess: 'Reference completed, {count} created, {skipped} skipped',
    referenceTaskSubmitted: 'Route copy task submitted. Task ID: {taskId}, requested {count}',
    referenceTaskAlreadyRunning: 'A route copy task is already running. Task ID: {taskId}',
    referenceError: 'Failed to reference',
    syncRelationLoadError: 'Failed to load routes for relation sync',
    selectRelationSyncWarning: 'Select routes to sync port relations',
    syncRelationSuccess: 'Synchronization completed, {count} relations changed',
    syncRelationTaskSubmitted: 'Sync task submitted. Task ID: {taskId}',
    syncRelationError: 'Failed to sync port relations',
    readonlyWarning: 'Referenced platform data is read-only',
    statusReadonlyWarning: 'This route cannot be enabled or disabled'
  }
}
